import ProgressPaidCell from "./ProgressPaidCell";
import ProgressFreeCell from "./ProgressFreeCell";

function ProgressCell({item, currentClass, paid, free, user}: any) {


    return <div key={'progressCell_' + item} className={'progressCell ' + currentClass + ' progressCell-' + item}>
        <div className={'progressPaidCell'}>
            <ProgressPaidCell key={'progressPaidCell_' + item} paid={paid} item={item}  />

            {((user.season_progress.currentLevel >= (parseInt(item) + 1) && user.premium)) ? (
                <div className={'progressDone'}></div>
            ) : ((user.season_progress.currentLevel >= (parseInt(item) + 1)) && !user.premium) ? (
                <div className={'progressLock'}></div>
            ) : (!user.premium) ? (
                <div className={'progressLock'}></div>
            ) : (
                <div></div>
            )}

        </div>
        <div className={'progressLevelCell'}>{parseInt(item) + 1}</div>
        <div className={'progressFreeCell'}>

            <ProgressFreeCell key={'progressFreeCell_' + item} free={free} item={item} />

            {(user.season_progress.currentLevel >= (parseInt(item) + 1)) ?
                <div className={'progressDone'}></div>
                : <div></div>}
        </div>
    </div>
}

export default ProgressCell;
